import { Icon } from '@/shared/ui/icon'
import { AvatarProps } from '../types'
import { commonSteamLogoStyles } from '../constants'

export const PlusAvatarSteam = (props: AvatarProps) => {
  const { isSteamLogo = true, width = 44, height = 44, src } = props
  const baseWidth = 42.881 - 1.11949
  const baseHeight = 39.5 - 0.5

  // Рассчитываем коэффициент масштабирования с учетом сохранения пропорций
  const scale = Math.min(width / baseWidth, height / baseHeight)

  const hexagonPath = `
    M${30.4821 * scale} ${0.5 * scale}
    C${32.1044 * scale} ${0.5 * scale} ${33.6089 * scale} ${1.37995 * scale} ${34.4279 * scale} ${2.81758 * scale}
    L${42.881 * scale} ${17.6563 * scale}
    C${43.7063 * scale} ${19.1051 * scale} ${43.7063 * scale} ${20.8949 * scale} ${42.881 * scale} ${22.3437 * scale}
    L${34.4279 * scale} ${37.1824 * scale}
    C${33.6089 * scale} ${38.6201 * scale} ${32.1044 * scale} ${39.5 * scale} ${30.4821 * scale} ${39.5 * scale}
    H${13.5219 * scale}
    C${11.8999 * scale} ${39.5 * scale} ${10.3956 * scale} ${38.6203 * scale} ${9.57651 * scale} ${37.1832 * scale}
    L${1.11949 * scale} ${22.3446 * scale}
    C${0.293504 * scale} ${20.8952 * scale} ${0.293504 * scale} ${19.1048 * scale} ${1.11948 * scale} ${17.6554 * scale}
    L${9.57649 * scale} ${2.81675 * scale}
    C${10.3956 * scale} ${1.37961 * scale} ${11.8999 * scale} ${0.5 * scale} ${13.5219 * scale} ${0.5 * scale}
    H${30.4821 * scale}Z
  `

  return (
    <div
      style={{
        width: `${width + 1}px`,
        height: `${height}px`,
        position: 'relative',
      }}
    >
      <svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox={`0 0 ${width + 2} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <clipPath id="hexagonClip">
            <path d={hexagonPath} />
          </clipPath>
        </defs>

        <image
          href={src}
          x="1.5"
          y="0"
          width={`${width}px`}
          height={`${height}px`}
          clipPath="url(#hexagonClip)"
          preserveAspectRatio="xMidYMid slice"
        />

        <path
          d={hexagonPath}
          stroke="#4A6BFC"
        />
      </svg>
      {isSteamLogo && (
        <Icon
          view="steamColor"
          style={commonSteamLogoStyles}
        />
      )}
    </div>
  )
}
